
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estimate/home",
      function () {
        return require("private-next-pages/estimate/home.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/estimate/home"])
      });
    }
  